export const recettePattern = "miamRecipeCard";

export const getProduitsRecetteParIndex = (produits, index, ignore_is_compatible_recette = false) => {
  let produitsRecette = [];
  if (produits.length < 2) {
    return produitsRecette;
  }

  if (index <= 0) {
    produitsRecette = produits.slice(0, 2);
  } else {
    produitsRecette = [produits[index - 1], produits[index]];
  }
  if (ignore_is_compatible_recette) {
    return produitsRecette.map(prd => prd.id)
  }
  return produitsRecette.filter(prd => prd.attributes.is_compatible_recette).map(prd => prd.id);
};

export const hasRecette = (zoneMerch) => {
  return zoneMerch && zoneMerch.html_content && zoneMerch.html_content.includes(recettePattern);
};
